import { Expose } from 'class-transformer'

export enum CarrierType {
  freight = 'freight',
  parcel = 'parcel',
}

export class Carrier {
  static Type = CarrierType

  static type = 'carrier'

  type = Carrier.type

  @Expose({ name: 'xid' })
  guid?: string

  name?: string

  @Expose({ name: 'carrier_type' })
  carrierType: CarrierType = CarrierType.freight

  static carrierTypeMap = {
    [CarrierType.freight]: 'Freight',
    [CarrierType.parcel]: 'Parcel',
  }

  get carrierTypeDisplay() {
    return Carrier.carrierTypeMap[this.carrierType]
  }

  @Expose({ name: 'scac_code' })
  scac?: string
}
